// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { ISuggestedFaq, SuggestedFaqStatus } from '@/models/suggestedFaq.model';
import { IPagination } from '@/models/pagination.model';

// Components
import { Pagination, Table, TSelectOptions } from '@/ui';

// Helpers
import { getSuggestedFaqColumns, TSuggestedFaqFilters } from '../../helpers';

type TSuggestedFaqTableProps = {
  data: ISuggestedFaq[] | null;
  isLoading?: boolean;
  pagination?: IPagination | null;
  onPageChange: (page: number) => void;
  filters?: TSuggestedFaqFilters;
  onFilterChange: <K extends keyof TSuggestedFaqFilters>(field: K, value: TSuggestedFaqFilters[K]) => void;
  statusOptions?: TSelectOptions<SuggestedFaqStatus>;
};

const SuggestedFaqTable: FC<TSuggestedFaqTableProps> = ({
  data,
  isLoading,
  pagination,
  onPageChange,
  filters,
  onFilterChange,
  statusOptions,
}) => {
  const { t } = useTranslation();

  const columns = getSuggestedFaqColumns({ t, filters, onFilterChange, statusOptions });

  return (
    <>
      <Table
        loading={isLoading}
        columns={columns}
        rowKey="reviewId"
        dataSource={data ?? []}
        pagination={false}
        scroll={{ x: 'max-content' }}
        size="small"
      />
      <Pagination
        hideOnSinglePage
        total={pagination?.total}
        current={pagination?.page}
        pageSize={pagination?.pageSize}
        align="center"
        onChange={onPageChange}
      />
    </>
  );
};

export default SuggestedFaqTable;
